module.exports = __webpack_public_path__ + "icon-math.png?d0865cd0d7306fa30d55d05cf4901649";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/icon-math.png
// module id = 64
// module chunks = 0